import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { GetGameCountByTypeDto } from "../../../models/analytics/dto/get-game-count-by-type.dto";
import { AnalyticsFilterParams, buildFilterSuffix } from "./analyticsFilterParams";

export const GET_GAME_COUNT_BY_TYPE_QUERY_KEY = 'gameCountByType';

export const useGetGameCountByType = (locationId?: string, startDate?: Date, endDate?: Date, filters?: AnalyticsFilterParams) => {
    const apiClient = useApiClient();
    return useQuery<GetGameCountByTypeDto>({
        queryKey: [GET_GAME_COUNT_BY_TYPE_QUERY_KEY, locationId, startDate, endDate, filters?.courtIds, filters?.sportTypes],
        queryFn: async () => {
            const dateSuffix = startDate && endDate ? `startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}` : '';
            return apiClient.fetchApi<GetGameCountByTypeDto, {}>({ method: 'GET', endpoint: `analytics/game-count-by-type?locationId=${locationId}&${dateSuffix}${buildFilterSuffix(filters)}` });
        },
        enabled: !!locationId,
        staleTime: 5 * 60 * 1000,
    });
}
